import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationReloadService {
  private forceReload = false;

  setForceReload(value: boolean): void {
    this.forceReload = value;
  }

  shouldForceReload(): boolean {
    const shouldReload = this.forceReload;
    // Reset the flag immediately after checking it
    if (shouldReload) {
      this.forceReload = false;
    }
    return shouldReload;
  }
} 